module.exports = __webpack_public_path__ + "static/img/MPAerweima.65ef710.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MPAerweima.jpg
// module id = sB8I
// module chunks = 49